
/* eslint-disable import/prefer-default-export */
export const de = {
  translation: {
    title: 'Elektronische beglaubigte Kopie prüfen',
    desc:'Geben Sie den CSV (Sicherer Verifizierungscode) ein und klicken Sie auf die Schaltfläche Prüfen, um die Authentizität und Integrität der elektronischen beglaubigten Kopie des notariellen Dokuments zu überprüfen sowie spätere rechtliche Änderungs- und Koordinierungshinweise mit anderen öffentlichen Urkunden einzusehen.',
    placeholderCSV:'CSV-Code',
    validateButton: 'Prüfen',
    backButton:'Zurück',
    okButton:'Akzeptieren',
    cancelButton:'Abbrechen',
    closeButton:'Schließen',
    actionsButton:'Aktionen',
    downloadButton:'Herunterladen',
    head:{
      title: 'NOTARIELLES ELEKTRONISCHES PORTAL',
    },
    footer:{
      legalNotice: 'Rechtlicher Hinweis',
      privacyPolicy: 'Datenschutz-Bestimmungen',
      accessibility: 'Barrierefreiheit',
      cookiesPolicy: 'Cookie-Richtlinie',
      supportedBrowsers: 'Unterstützte Browser',
    },
    modalsupportedbrowsers:{
      other: 'Sie können mit einem PC, Mac, Mobilgerät oder Tablet zugreifen.',
    },
    actions: {
      helpButton:'Hilfe anzeigen',
      validateSignature:'Signatur prüfen',
      download:'Herunterladen',
      downloadCombined: 'Kombiniert herunterladen'
    },
    modalAyuda:{
      title:'Hilfe',
      guide:'Hier können Sie die zu diesem Abschnitt gehörige Anleitung herunterladen',
      section1: 'Überprüfung der Signatur über das notarielle elektronische Portal',
      desc1: 'Um die Gültigkeit der qualifizierten elektronischen Signatur des Notars im notariellen Dokument zu überprüfen, klicken Sie auf die Schaltfläche <strong>Aktionen</strong> und wählen Sie <strong>Signatur prüfen</strong>.',
      section2: 'Überprüfung der Signatur mit Adobe Acrobat Reader',
      desc2: 'Um die Gültigkeit der qualifizierten elektronischen Signatur des Notars im notariellen Dokument zu überprüfen, klicken Sie auf <strong>Aktionen</strong> und wählen Sie <strong>Herunterladen</strong>. Öffnen Sie anschließend das Dokument mit Adobe Acrobat Reader und klicken Sie auf das Stiftsymbol im Seitenmenü. <br /><br /> In der Dropdown-Liste können Sie die Gültigkeit der Signatur überprüfen und deren Details analysieren.',
      section3: 'Überprüfung der Signatur mit VALIDe',
      desc3: 'Um die Gültigkeit der qualifizierten elektronischen Signatur des Notars im notariellen Dokument zu überprüfen, klicken Sie auf <strong>Aktionen</strong> und wählen Sie <strong>Herunterladen</strong>. Verwenden Sie anschließend die',
      linkText: 'öffentliche VALIDe-Plattform',
    },
    modalCopia:{
      title:'Elektronische beglaubigte Kopie',
    },
    modalErrorServicio:{
      desc: 'Es existiert keine elektronische beglaubigte Kopie, die mit dem eingegebenen CSV-Code verknüpft ist. Bitte überprüfen Sie den Code und versuchen Sie es erneut.',
      contactSupport: 'Wenn weiterhin Probleme auftreten, können Sie den Support kontaktieren.',
    },
    modalAdvertenciaDescarga:{
      title:'Warnung',
      desc:'<strong>Die Hinweise</strong> zu rechtlichen Änderungen und zur Koordination mit anderen öffentlichen Urkunden, die <strong>nach Ausstellung der Kopie erstellt wurden, sind im heruntergeladenen Dokument nicht enthalten.</strong> Sie erscheinen nur auf dem Ausstellungsnachweis.',
    },
    modalErrorGenerico:{
      desc:'Ein Problem ist aufgetreten. Bitte versuchen Sie es erneut.',
    },
    modalErrorValidacion:{
      title:'Fehler bei der Signaturprüfung.',
      desc:'Die Signatur des Dokuments konnte nicht geprüft werden. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support.',
    },
    modalManuales:{
      name:'Name',
    },
    modalValidacionFirma:{
      title:'Signatur prüfen',
      firmaNotario:'QUALIFIZIERTE NOTARSIGNATUR:',
      fechaFirma:'SIGNATURDATUM:',
      fechaValidacion:'PRÜFDATUM:',
      estadoFirma:'SIGNATURSTATUS:',
      validacionFirma:'Elektronische Signaturprüfung des Generalrats des Notariats',
      validada:'Validiert',
      noValidada:'Nicht validiert',
      contenido:'Dokumentinhalt',
      alterado:'verändert',
      noAlterado:'nicht verändert',
      certificadoFirmante:'Zertifikat des Unterzeichners',
      caducado:'abgelaufen',
      noCaducado:'nicht abgelaufen',
      revocado:'widerrufen',
      noRevocado:'nicht widerrufen',
      certificadoCa:'von einer vertrauenswürdigen Zertifizierungsstelle (CA) ausgestellt',
      noCertificadoCa:'nicht von einer vertrauenswürdigen CA ausgestellt',
    },
  },
};
